import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { invitationService } from '@api/services/services';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { InvitationDto } from '@api/models/invitation/InvitationDto';

type State = BaseType<InvitationDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsInvitationSlice = baseSlice({
  name: 'optionsInvitation',
  initialState,
});

export const selectOptionsInvitationState = (state: RootState) => state.optionsInvitation.state;
export const selectOptionsInvitation = (state: RootState) => state.optionsInvitation.data.map((x) => ({ id: x.id, name: x.name } as ReferenceDto));
export const optionsInvitationActions = optionsInvitationSlice.actions;

export const getOptionsInvitation = (search: string | undefined, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const handleGetData = async () => {
    const response = await invitationService.query(
      {
        q: search,
        page: 0,
        size: AUTOCOMPLETE_MAX_ITEMS,
        sort: ['name', 'asc'],
      },
      { cancelToken: cancelToken }
    );
    return { data: response.data.content ?? [] };
  };

  getItem({
    dispatch,
    actions: optionsInvitationActions,
    getData: handleGetData,
  });
};
